export const counter = {
  InsuredSection: 'rs.burial.PolicyHolderSection.Index',
  SectionWise:'rs.burial.Seguros-De-DecesosSectionWise.Index'
}
